import { teamOffersExchanges } from "../login/login";

export namespace HeaderText {
  export const EXCHANGES = "Returns & Exchanges";
  export const NO_EXCHANGES = "Returns";
}

export namespace ButtonText {
  export const EXCHANGES = "Start Exchange or Return";
  export const NO_EXCHANGES = "Start a Return";
}

export const getHeaderText = (settings) => {
  if (settings.returnPortalHeaderText) {
    return settings.returnPortalHeaderText;
  }
  if (teamOffersExchanges(settings.returnFlow)) {
    return HeaderText.EXCHANGES;
  }

  return HeaderText.NO_EXCHANGES;
};

export const getButtonText = (settings) => {
  if (settings.returnPortalButtonText) {
    return settings.returnPortalButtonText;
  }
  if (teamOffersExchanges(settings.returnFlow)) {
    return ButtonText.EXCHANGES;
  }

  return ButtonText.NO_EXCHANGES;
};
